import { ClientJS } from 'clientjs';
const client = new ClientJS()

export const getBrowserSession = () => {
    const fp = client.getCustomFingerprint(
        client.getUserAgent(),
        client.getLanguage(),
        client.getTimeZone(),
        client.getCurrentResolution(),
        client.getOS(),
        client.getOSVersion(),
        client.getBrowser(),
        client.getBrowserVersion(),
    );
    const thisSession = {
        useAgent: client.getUserAgent(),
        fingerPrint: String(fp),
        os: client.getOS() + ' ' + client.getOSVersion(),
        browser: client.getBrowser() + ' ' + client.getBrowserMajorVersion(),
        resolution: client.getAvailableResolution(),
        isMobile: client.isMobile(),
    }
    return thisSession;
}
